enum ASYNC_STATE {
  NOT_STARTED = 'NOT_STARTED',
  LOADING = 'LOADING',
  DONE = 'DONE',
  ERROR = 'ERROR',
}

export default ASYNC_STATE;
